import { render, staticRenderFns } from "./zdgllbcz.vue?vue&type=template&id=d643d7a4&scoped=true&"
import script from "./zdgllbcz.vue?vue&type=script&lang=js&"
export * from "./zdgllbcz.vue?vue&type=script&lang=js&"
import style0 from "./zdgllbcz.vue?vue&type=style&index=0&id=d643d7a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d643d7a4",
  null
  
)

export default component.exports